export const PageDataState = {
    Searchs: {
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            placeholder: 'ผู้ประกอบการ',
        }, 
        name: {
            type: 'text',
            id: 'name',
            label: 'ประกาศ',
            value: '',
            placeholder: 'ประกาศ',
        },
        position_id: {
            type: 'select',
            id: 'position_id',
            label: 'ตำแหน่ง',
            value: '',
            placeholder: 'ตำแหน่ง',
        },
        start_publicize_date: {
            type: 'text',
            id: 'start_publicize_date',
            label: 'เริ่มต้น',
            value: '',
            placeholder: 'เริ่มต้น',
        },
        end_publicize_date: {
            type: 'text',
            id: 'end_publicize_date',
            label: 'สิ้นสุด',
            value: '',
            placeholder: 'สิ้นสุด',
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            placeholder: 'สถานะ',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },       
        types: {
            type: 'select',
            id: 'types',
            label: 'ประกาศโดย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }, 
        user_id: {
            type: 'select',
            id: 'user_id',
            label: 'ผู้ใช้งาน',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        }, 
        name: {
            type: 'text',
            id: 'name',
            label: 'ประกาศ',
            value: '',
            placeholder: 'ประกาศ',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },  
        detail: {
            type: 'textarea',
            rows: 8,
            id: 'detail',
            label: 'รายละเอียด',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        position_id: {
            type: 'select',
            id: 'position_id',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        people_count: {
            type: 'text',
            id: 'people_count',
            label: 'จำนวน',
            value: '',
            placeholder: 'จำนวน',
            validator: {
                type: 'number',
                required: true,
                minLength: 1,
                maxLength: 1000
            },
            error: { status: null, msg: '' }            
        }, 
        contact_detail: {
            type: 'textarea',
            rows: 5,
            id: 'contact_detail',
            label: 'ข้อมูลการติดต่อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },
        photo: {
            type: 'file',
            id: 'photo',
            label: 'รูปภาพ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        files: {
            type: 'file',
            id: 'files',
            label: 'ไฟล์แนบ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            },
            error: { status: null, msg: '' }
        },
        publicize_date: {
            type: 'text',
            id: 'publicize_date',
            label: 'วันที่ประกาศ',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        expired_date: {
            type: 'text',
            id: 'expired_date',
            label: 'วันที่สิ้นสุด',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }        
    },
    InputGroup: {}
}    